<template>
  <div>
    <a-card  v-if="viewcustomerList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="账单号"  style="margin-left: 60px">
                <a-input v-model.trim="queryParam.statementNo"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="账单状态" :labelCol="labelCol" :wrapperCol="wrapperCol"style="margin-left: 45px">
                <a-select  v-model="queryParam.statementStatus"@change="installChange" :allowClear="true">
                  <a-select-option  v-for="type in statement_status":title="type.dictLabel" :key="type.dictValue">{{type.dictLabel}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="收款状态" style="margin-left: 45px">
                <a-select  v-model="queryParam.receiveMoneyStatus" :allowClear="true">
                  <a-select-option  v-for="type in receive_money_status":title="type.dictLabel" :key="type.dictValue">{{type.dictLabel}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单总计" :labelCol="labelCol" :wrapperCol="wrapperCol"style="margin-left: 45px">
                <a-col :span="11">
                  <a-input placeholder="最小值" v-model.trim="queryParam.orderTotalNumBegin"/>
                </a-col>
                <a-col :span="2" style="display: flex;justify-content: center">
                  -
                </a-col>
                <a-col :span="11">
                  <a-input placeholder="最大值"  v-model.trim="queryParam.orderTotalNumEnd"/>
                </a-col>
              </a-form-item>

            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="收款时间" style="margin-left: 45px">
                <a-range-picker v-model="receiveMoney"
                                style="width: 100%"
                                :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                                format="YYYY-MM-DD HH:mm:ss" @change="onChange_b"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单号" style="margin-left: 60px">
                <a-input v-model.trim="queryParam.orderNo"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="建单时间" style="margin-left:  45px">
                <a-range-picker
                  v-model="createTime"
                  style="width: 100%"
                  :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChange_e"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="账单截止日期" :labelCol="labelCol" :wrapperCol="wrapperCol"style="margin-left:  15px">
                <a-range-picker v-model="closingDate"
                                style="width: 100%"
                                :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                                format="YYYY-MM-DD HH:mm:ss"@change="onChange_a"  />
              </a-form-item>
            </a-col>

          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item  label="客户姓名" style="margin-left:  45px">
                <a-input v-model.trim="queryParam.clientName"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item  label="客户联系方式" style="margin-left:  15px">
                <a-input v-model.trim="queryParam.clientPhone"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-row :gutter="24" style="margin-left: 0px">
                <a-form-item  label="客户地址"style="margin-left: 45px">
                  <a-col :md="5" :sm="24">
                    <a-select  v-model="queryParam.provinceId"
                              @change="getselect" :allowClear="true">
                      <a-select-option  v-for="type in selectAllProvince" :title="type.provinceName":key="type.provinceCode">{{type.provinceName}}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select  v-model="queryParam.cityId"
                              @change="getprovinceName" :allowClear="true">
                      <a-select-option  v-for="type in selectCityName":title="type.cityName" :key="type.cityCode">{{type.cityName}}</a-select-option>
                    </a-select >
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select  v-model="queryParam.areaId"  :allowClear="true">
                      <a-select-option  v-for="type in selectAreaName" :title="type.areaName":key="type.areaCode">{{type.areaName}}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="9" :sm="24">
                    <a-input  v-model.trim="queryParam.clientAddress"/>
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
          </a-row>
          <a-row :gutter="24">

            <a-col :md="6" :sm="24">
              <a-form-item label="生成对账单时间" >
                <a-range-picker v-model="createStatement"
                                style="width: 100%"
                                :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                                format="YYYY-MM-DD HH:mm:ss"@change="onChange_d"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单完成时间" style="margin-left:  15px">
                <a-range-picker
                  v-model="completeTime"
                  style="width: 100%"
                  :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChange_f"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <!--        筛选的条件-->
          <!--查询 清空-->
          <span class="table-page-search-submitButtons">
          <a-row type="flex" justify="space-between">
                 <a-col :span="18"></a-col>
            <a-col :span="6":style="{ textAlign: 'right' }" >
              <a-button type="primary"  htmlType="submit" @click="query">查询</a-button>
              <a-button style="margin-left: 8px" @click="empty">清空</a-button>
          <a-button style="margin-left: 8px" type="primary" v-if="exportStatementsCustomerStatement"
                    @click="exportEnt() ">导出 Excel</a-button>
            </a-col>

          </a-row>
        </span>
        </a-form>
      </div>
      <!--    表格内容-->
      <a-table
        size="default"
        ref="table"
        :columns="columns"
        :pagination="false"
        :dataSource="this.subList.rows"
        bordered

        :scroll="{ x: 1600}"
      >

      <span slot="action" slot-scope="text, record" style="white-space: nowrap;">
         <a v-if="checkCustomerList"  @click="reconciliation(record)"> 对账</a>

      </span>
      </a-table>

      <a-pagination showQuickJumper="true" showSizeChanger
                    :pageSizeOptions="pageSizeOptions"
                    :pageSize.sync="pageSize"
                    @showSizeChange="onShowSizeChange"
                    :total="total"
                    v-model="current"
                    @change="getdataList1"
                    :showTotal="total => `总共 ${total} 条`"
                    style="text-align: end;margin-top: 20px"
      />
      <!--    最后字段-->
      <a-row  style="margin-top: 20PX" v-if="subList.statistics">
        <a-col :span="19" style="margin: 10px 0">
          <a-row>
            <a-col :span="5" >
            </a-col>
            <a-col :span="19"style="text-align: center" >
            <span
              style="font-size: 14px;font-weight: 700 ;text-align: center">结算金额：{{subList.statistics.enterpriseSettleAmount}}元       已结算金额：{{subList.statistics.alreadySettleAmount}}元
              实际需结算：{{subList.statistics.needSettleAmount}}元    已退款金额：{{subList.statistics.alreadyRefundAmount}}元    订单总计：{{subList.statistics.orderNum}}单</span>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <!-- 使用弹框组件-->
      <!--<Customer-modal ref="modal" @ok="handleOk"/>-->
      <customer-reconciliation-model ref="customerReconciliation"  @ok="query"></customer-reconciliation-model>
    </a-card>
    <no-authority v-else></no-authority>
  </div>

</template>
<script>
  import NoAuthority from '../enterprise/NoAuthority'
  import {ACCESS_TOKEN} from '@/store/mutation-types'
  import moment from 'moment';
  import {getfinddictAll} from
      '@/api/order/orderList'
  import { STable } from '@/components'
  import { getSubList,getSubStatementDetailList,getexportList } from '@/api/finance/customerList'
  import CustomerModal from './modules/CustomerModal.vue'
  import customerReconciliationModel from './modules/customerReconciliationModel.vue'
  import { checkPermission } from '@/utils/permissions'
  import {getDictMap} from "../../utils/dict"
  import CustomerReconciliation from "./modules/customerReconciliationModel";
  export default {
    name: 'customerList',
    components: {
      CustomerReconciliation,
      STable,
      // 注册弹框组件
      CustomerModal,
      customerReconciliationModel,
      NoAuthority
    },
    data () {
      return {
        // 分页
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        total:0,
        current:1,
        pageSize:10,


        subList:'',
        // 根据单个id获取到的数据
        Settlementlist:[],
        selectedRowKeys: [], // Check here to configure the default column
        selectedRow:[],
        disabled:true,
        loading: false,
        completeTime:'',
        createTime:'',
        closingDate:'',
        createStatement:'',
        receiveMoney:'',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN)
        },
        form: this.$form.createForm(this),
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: 'rowNum',
            align:'center'
          },
          {
            title: '操作栏',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },

          },
          {
            title: '账单状态',
            dataIndex: 'statementStatus',
            align:'center'
          },{
            title: '企业名称',
            dataIndex: 'enterpriseName',
            align:'center'
          },
          {
            title: '账单号',
            dataIndex: 'statementNo',
            align:'center'
          },{
            title: '账单截止日期',
            dataIndex: 'closingDate',
            align:'center'
          },{
            title: '收款状态',
            dataIndex: 'receiveMoneyStatus',
            align:'center'
          }, {
            title: '收款时间',
            dataIndex: 'receiveMoneyTime',
            align:'center'
          }, {
            title: '订单总计',
            dataIndex: 'orderNum',
            align:'center'
          },{
            title: '安装数量',
            dataIndex: 'installNum',
            align:'center'
          },
          {
            title: '客户自费订单总金额',
            dataIndex: 'customerTotalAmount',
            align:'center'
          },
          {
            title: '客户自费结算总金额',
            dataIndex: 'customerSettleAmount',
            align:'center'
          }, {
            title: '已退款金额',
            dataIndex: 'alreadyRefundAmount',
            align:'center'
          }, {
            title: '开票状态',
            dataIndex: 'invoiceStatus',
            align:'center',
          customRender: (text) => {
        if (text=='1') {
          return '已开票'
        } else {
          return '未开票'
        }
      }
          },{
            title: '生成对账单时间',
            dataIndex: 'createStatementTime',
            align:'center'
          },
        ],
        receive_money_status:[],
        statement_status:[],
        // 字典为开票状态
        timetype:[],
        exportStatementsCustomerStatement: checkPermission('exportStatementsCustomerStatement'),
        checkCustomerList: checkPermission('checkCustomerList'),
        viewcustomerList: checkPermission('viewcustomerList'),

      }
    },
    filters: {
    },
    // 下拉框的选项
    async created () {
      this.getdataList1(1)
      // await getSubList().then(res=>{
      //   if (res.code===0){
      //     this.subList=res
      //   }else {
      //     this.$message.error(res.msg);
      //   }
      // })
      let dictTypes=['invoice_status','receive_money_status','statement_status']
      getfinddictAll({dictTypes:dictTypes.join()}).then(res => {
        this.timetype=res.invoice_status
        this.receive_money_status=res.receive_money_status
        this.statement_status=res.statement_status
      })

    },
    methods: {

      // 分页
      onShowSizeChange(current, pageSize) {
        this.pageSize = pageSize;
        this.getdataList1(current)
      },

      getdataList1(value){
        this.queryParam.pageNum = value
        this.queryParam.pageSize = this.pageSize
        this.handloadData()
      },
      handloadData() {
        getSubList(this.queryParam).then(res => {
          console.log(res)
          this.subList = res
          this.total = res.total
        })
      },

      SetOptionTitle(){
        var selects = document.getElementsByTagName("select");
        if (selects.length > 0) {
          for (var i = 0; i < selects.length; i++) {
            var options = selects[i].options;
            if (selects[i].options.length > 0) {
              for (var j = 0; j < options.length; j++) {
                if (options[j].title == "")
                  options[j].title = options[j].text;
              }
            }
          }
        }
      },
      empty(){
        // this.queryParam={}

        this.queryParam.statementNo =''
        this.queryParam.statementStatus =''
        this.queryParam.receiveMoneyStatus =''
        this.queryParam.orderTotalNumBegin =''
        this.queryParam.orderTotalNumEnd =''
        this.queryParam.orderNo =''
        this.queryParam.clientName =''
        this.queryParam.clientPhone =''
        this.queryParam.provinceId =''
        this.queryParam.cityId =''
        this.queryParam.areaId =''
        this.queryParam.clientAddress =''

        this.completeTime=''
        this.createTime=''
        this.closingDate=''
        this.createStatement=''
        this.receiveMoney=''
      },
      moment,
      exportEnt () {
        var str=process.env.VUE_APP_API_BASE_URL + '/finance/customerStatement/subExport?pageNum=1&pageSize=10'
        for(let i in this.queryParam ){
          if(this.queryParam[i]!=undefined){
            str=str+'&'+i+'='+this.queryParam[i]
          }
        }
        str=str+'&token='+this.headers.token
        window.open(str)

      },
      query(){
        getSubList(this.queryParam).then(res=>{
          if (res.code===0){
            this.subList=res
          }else {
            this.$message.error(res.msg);
          }
        })
      },
      // 账单截止日期
      onChange_a(date, dateString) {
        this.queryParam.closingDateBegin=dateString[0]
        this.queryParam.closingDateEnd=dateString[1]
      },
      // 结算时间
      onChange_b(date, dateString) {
        this.queryParam.receiveMoneyTimeBegin=dateString[0]
        this.queryParam.receiveMoneyTimeEnd=dateString[1]
      },
      onChange_d(date, dateString) {
        this.queryParam.createStatementTimeBegin=dateString[0]
        this.queryParam.createStatementTimeEnd=dateString[1]
      },
      onChange_e(date, dateString) {
        this.queryParam.createOrderTimeBegin=dateString[0]
        this.queryParam.createOrderTimeEnd=dateString[1]
      },
      onChange_f(date, dateString) {
        this.queryParam.completeOrderTimeBegin=dateString[0]
        this.queryParam.completeOrderTimeEnd=dateString[1]
      },
      handleChangeMin(e){
        this.queryParam.orderTotalNumBegin=e.target.value
      },
      handleChangeMax(e){
        this.queryParam. orderTotalNumEnd=e.target.value
      },
      // 对账
      reconciliation(record){
        this.$refs.customerReconciliation.showCustomerReconciliation(record.statementId)
       // console.log(record.statementId)
        // this.$router.push({name:'customerReconciliation',params:{statementId:record.statementId}})
        // getSubStatementDetailList({statementId:record.statementId}).then(res=>{
        //   if (res.code===0){
        //     this.$refs.customerReconciliation.showCustomerReconciliation(res.data)
        //   }else {
        //     this.$message.error(res.msg);
        //   }
        // })
      },

    },
    watch: {
    }
  }
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  white-space: nowrap;padding: 4px 16px;}
</style>